<template>
  <div v-if="page" class="min-h-screen bg-gradient-to-b from-soft-white to-lavender-tint/30">
    <section class="container mx-auto px-6 pt-10 pb-16 max-w-6xl">
      <RouterLink to="/jobs" class="text-sm text-light-purple font-medium mb-4 inline-block">
        ← All phlebo jobs
      </RouterLink>
      <div class="grid lg:grid-cols-[1.15fr_0.85fr] gap-8 items-start">
        <article>
          <p class="text-sm font-semibold text-light-purple uppercase tracking-wide mb-2">
            {{ page.locationLabel }} · Always-open network
          </p>
          <h1 class="text-3xl md:text-5xl font-poppins font-bold text-dark-gray mb-4">
            {{ page.h1 }}
          </h1>
          <p class="text-dark-gray/55 text-sm mb-6">
            People also search:
            <span class="font-medium text-dark-gray">{{ page.keyword }}</span>
          </p>

          <div class="card-neumorphic !p-6 space-y-4 text-dark-gray/80 leading-relaxed mb-6">
            <p v-for="(para, i) in page.body" :key="i">{{ para }}</p>
          </div>

          <div v-if="page.faqs?.length" class="card-neumorphic !p-6 mb-6">
            <h2 class="text-xl font-semibold text-dark-gray mb-4">FAQs</h2>
            <div v-for="f in page.faqs" :key="f.q" class="mb-3">
              <h3 class="font-semibold text-dark-gray text-sm">{{ f.q }}</h3>
              <p class="text-sm text-dark-gray/70">{{ f.a }}</p>
            </div>
          </div>

          <div class="card-neumorphic !p-5 text-sm text-dark-gray/70">
            <p class="mb-2">
              Corporates & labs:
              <RouterLink to="/services/phlebotomy-services-kerala" class="text-light-purple font-medium">
                hire Homvisit services
              </RouterLink>
              — this page is for phlebotomists joining the network.
            </p>
            <p>
              Call
              <a :href="`tel:${phoneTel}`" class="text-light-purple font-semibold">{{ phoneDisplay }}</a>
              ·
              <a :href="`mailto:${email}`" class="text-light-purple font-semibold">{{ email }}</a>
            </p>
          </div>
        </article>

        <JobApplyForm
          :default-district="page.defaultDistrict || ''"
          :source-page="`/jobs/${page.slug}`"
        />
      </div>
    </section>
  </div>
  <div v-else class="p-20 text-center">Page not found.</div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import JobApplyForm from '../components/JobApplyForm.vue'
import { getJobPage } from '../config/jobPages'
import {
  CONTACT_EMAIL,
  CONTACT_PHONE_DISPLAY,
  CONTACT_PHONE_TEL,
  SITE_URL,
} from '../config/contact'
import {
  breadcrumbSchema,
  faqSchema,
  graphSchema,
  jobPostingSchema,
  organizationSchema,
  useSeo,
} from '../composables/useSeo'

export default {
  name: 'JobSeoPage',
  components: { JobApplyForm },
  setup() {
    const route = useRoute()
    const page = computed(() => getJobPage(route.params.slug))

    useSeo(
      computed(() => {
        const p = page.value
        if (!p) return { title: 'Not found | Homvisit', robots: 'noindex', path: '/jobs' }
        const path = `/jobs/${p.slug}`
        return {
          title: p.title,
          description: p.description,
          path,
          keywords: [p.keyword, 'phlebotomist jobs kerala', 'homvisit network'],
          schema: graphSchema([
            organizationSchema(),
            breadcrumbSchema([
              { name: 'Home', path: '/' },
              { name: 'Jobs', path: '/jobs' },
              { name: p.h1, path },
            ]),
            jobPostingSchema({
              title: p.h1,
              description: p.description,
              url: `${SITE_URL}${path}`,
              location: p.locationLabel,
            }),
            faqSchema(p.faqs),
          ]),
        }
      })
    )

    return {
      page,
      phoneDisplay: CONTACT_PHONE_DISPLAY,
      phoneTel: CONTACT_PHONE_TEL,
      email: CONTACT_EMAIL,
    }
  },
}
</script>
